import { Component, OnInit, Input, Injector } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { TranslateService } from '@ngx-translate/core';
import { tBedService } from 'src/app/services/tBed.service';
import { tShopService } from 'src/app/services/tShop.service';
import { tShopBldgService } from 'src/app/services/tShopBldg.service';
import { tMedicineService } from 'src/app/services/tMedicine.service';
import { tPatientTypeService } from 'src/app/services/tPatientType.service';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { tVendorService } from 'src/app/services/tVendor.service';
import { tBookAuxService } from 'src/app/services/tBookAux.service';
import { tChangeAcctService } from 'src/app/services/tChangeAcct.service';
import { tItemCateService } from 'src/app/services/tItemCate.service';
import { tItemService } from 'src/app/services/tItem.service';
import { tPatientService } from 'src/app/services/tPatient.service';
import { tPackageService } from 'src/app/services/tPackage.service';
import { tPaymentService } from 'src/app/services/tPayment.service';
import { tPriceBookService } from 'src/app/services/tPriceBook.service';
import { tInvtService } from 'src/app/services/tInvt.server';
import { tInvtModel, StockManagementClass } from 'src/app/models/tInvtModel';
import { tBillPayService } from 'src/app/services/tBillPay.service';
import { VoidVoucherListClass } from 'src/app/models/tConsultHeadModel';
import { isNullOrUndefined } from 'util';


export const ServicesMapping = {
  tBedService: tBedService,
  tShopService: tShopService,
  tShopBldgService: tShopBldgService,
  tMedicineService: tMedicineService,
  tPatientTypeService: tPatientTypeService,
  tEmployeeService: tEmployeeService,

  tVendorService: tVendorService,
  tBookAuxService: tBookAuxService,

  tChangeAcctService: tChangeAcctService,
  tItemCateService: tItemCateService,

  tPatientService: tPatientService,
  tItemService: tItemService,

  tPackageService: tPackageService,

  tPaymentService: tPaymentService,
  tPriceBookService: tPriceBookService,
  tInvtService: tInvtService,
  tBillPayService: tBillPayService
}

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  styleUrls: ['./confirm-delete-dialog.component.css']
})
export class ConfirmDeleteDialogComponent implements OnInit {

  @Input() action: string;
  @Input() tableKeyValue: string;
  @Input() data: any;

  private TAG = "ConfirmDeleteDialog";
  displayMsg: string;
  deleteKeyID: any;

  submitted = false;

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private modalService: NgbModal,
    private apiResultDialogService: ApiResultDialogService,
    private injector: Injector,
    private translate: TranslateService

    // private systemBedService: SystemBedService
  ) { }

  ngOnInit() {
    this.displayMsg = this.getDisplayMsg(this.tableKeyValue);

    if (!isNullOrUndefined(localStorage.getItem('extraDialogMsg'))) {

      this.displayMsg += ' ' + localStorage.getItem('extraDialogMsg');
      localStorage.removeItem('extraDialogMsg');
    }

  }

  confirm() {
    this.log.i(this.TAG, "do confirm buttonaction = " + this.action + " , table = " + this.tableKeyValue);
    this.delete(this.tableKeyValue);
  }

  delete(tableKeyValue: string) {
    let configService: any;
    let returnDisplayMsg: string;

    this.log.i(this.TAG, "tableKeyValue = " + tableKeyValue);
    switch (tableKeyValue) {
      case MastersKeyStringValue.TABLE_Bed:
        // let systemBedService: SystemBedService;
        // configService = systemBedService;
        configService = this.injector.get<any>(ServicesMapping['tBedService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Bed);

        break;
      case MastersKeyStringValue.TABLE_Shop:
        configService = this.injector.get<any>(ServicesMapping['tShopService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Shop);

        break;
      case MastersKeyStringValue.TABLE_ShopBldg:
        configService = this.injector.get<any>(ServicesMapping['tShopBldgService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_ShopBldg);

        break;
      case MastersKeyStringValue.TABLE_Medicine:
        configService = this.injector.get<any>(ServicesMapping['tMedicineService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Medicine);

        break;
      case MastersKeyStringValue.TABLE_PatientType:
        configService = this.injector.get<any>(ServicesMapping['tPatientTypeService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_PatientType);

        break;
      case MastersKeyStringValue.TABLE_Employee:
        configService = this.injector.get<any>(ServicesMapping['tEmployeeService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Employee);

        break;
      case MastersKeyStringValue.TABLE_Vendor:
        configService = this.injector.get<any>(ServicesMapping['tVendorService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Vendor);

        break;
      case MastersKeyStringValue.TABLE_BookAux:
        configService = this.injector.get<any>(ServicesMapping['tBookAuxService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_BookAux);

        break;
      case MastersKeyStringValue.TABLE_ChangeAcct:
        configService = this.injector.get<any>(ServicesMapping['tChangeAcctService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_ChangeAcct);

        break;
      case MastersKeyStringValue.TABLE_Item:
        configService = this.injector.get<any>(ServicesMapping['tItemService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Item);
        break;
      case MastersKeyStringValue.TABLE_ItemCate:
        configService = this.injector.get<any>(ServicesMapping['tItemCateService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_ItemCate);
        break;
      case MastersKeyStringValue.TABLE_Patient:
        configService = this.injector.get<any>(ServicesMapping['tPatientService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Patient);
        break;
      case MastersKeyStringValue.TABLE_Package:
        configService = this.injector.get<any>(ServicesMapping['tPackageService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Package);
        break;
      case MastersKeyStringValue.TABLE_Payment:
        configService = this.injector.get<any>(ServicesMapping['tPaymentService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_Payment);
        break;
      case MastersKeyStringValue.TABLE_PriceBook:
        configService = this.injector.get<any>(ServicesMapping['tPriceBookService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_PriceBook);
        break;
      case MastersKeyStringValue.TABLE_Inbound:
        configService = this.injector.get<any>(ServicesMapping['tInvtService']);
        this.deleteStockData(configService, this.data, MastersKeyStringValue.TABLE_Inbound);
        break;
      case MastersKeyStringValue.TABLE_Outbound:
        configService = this.injector.get<any>(ServicesMapping['tInvtService']);
        this.deleteStockData(configService, this.data, MastersKeyStringValue.TABLE_Outbound);
        break;
      case MastersKeyStringValue.TABLE_VoidVoucher_VoidPayment:
        configService = this.injector.get<any>(ServicesMapping['tBillPayService']);
        this.voidPayment(configService, this.data, MastersKeyStringValue.TABLE_VoidVoucher_VoidPayment);
        break;
      case MastersKeyStringValue.TABLE_VoidVoucher_VoidBill:
        configService = this.injector.get<any>(ServicesMapping['tBillPayService']);
        this.voidBill(configService, this.data, MastersKeyStringValue.TABLE_VoidVoucher_VoidBill);
        break;
      case MastersKeyStringValue.TABLE_GRN:
        configService = this.injector.get<any>(ServicesMapping['tGRNService']);
        this.normalDelete(configService, this.data, MastersKeyStringValue.TABLE_GRN);
        break;




      default:
        configService = "";

        break;
    }

  }

  voidBill(configService: any, dataIn: VoidVoucherListClass, tableKey: string) {
    let returnDisplayMsg: string;

    configService.VoidBill(dataIn.clthConsultNumber)
      .subscribe(
        (data: any) => {
          //TODO error handler
          this.log.i(this.TAG, 'onSubmit VoidPayment success');
          // this.isLoading = false;
          // this.refreshData();

          this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
            returnDisplayMsg = res;
          });

          this.log.i(this.TAG, "delete success... return msg = " + returnDisplayMsg);
          this.activeModal.close('delete success');

          returnDisplayMsg += ' 發票號碼: ' + dataIn.clthBillingNumber;
1
          this.openConfirmModal(MastersKeyStringValue.STATUS_SUCCESS, returnDisplayMsg);

        },
        err => {
          this.log.e(this.TAG, 'onsubmit error = ' + JSON.stringify(err));
          // this.apiResultHandlerService.ErrHandler();
          // this.isLoading = false;
          this.translate.get('ReturnStatus_Fail').subscribe((res: string) => {
            returnDisplayMsg = res;
          });
          this.activeModal.dismiss('delete fail');

          returnDisplayMsg += ' 發票號碼: ' + dataIn.clthBillingNumber;

          this.openConfirmModal(MastersKeyStringValue.STATUS_FAIL, returnDisplayMsg);

        });
  }

  voidPayment(configService: any, dataIn: VoidVoucherListClass, tableKey: string) {
    let returnDisplayMsg: string;
    this.log.i(this.TAG, 'onSubmit VoidPayment data = ' + JSON.stringify(dataIn));
    this.submitted = true;

    configService.VoidPayment(dataIn.paymentNumber)
      .subscribe(
        (data: any) => {
          //TODO error handler
          this.log.i(this.TAG, 'onSubmit VoidPayment success');
          // this.isLoading = false;
          // this.refreshData();

          if (data.statusCode == "200") {
            this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
              returnDisplayMsg = res;
            });
          }else if (data.statusCode == "400"){
  

            returnDisplayMsg = data.message;
          }
           else {
            this.translate.get('ReturnStatus_Fail').subscribe((res: string) => {
              returnDisplayMsg = res;
            });
          }
          if(data.data==true){

            var displayMsg = "";
            this.translate.get('errMesssageYrEnd').subscribe((res: string) => {
              displayMsg = res;
            });
            window.alert(displayMsg);
          
        }
        //  returnDisplayMsg += ' 嘗試刪除發票號碼: ' + dataIn.clthBillingNumber;

          this.log.i(this.TAG, "delete success... return msg = " + returnDisplayMsg);
          this.activeModal.close('delete success');
          this.openConfirmModal(MastersKeyStringValue.STATUS_SUCCESS, returnDisplayMsg);

        },
        err => {
          this.log.e(this.TAG, 'onsubmit error = ' + JSON.stringify(err));
          // this.apiResultHandlerService.ErrHandler();
          // this.isLoading = false;
          this.translate.get('ReturnStatus_Fail').subscribe((res: string) => {
            returnDisplayMsg = res;
          });
          this.activeModal.dismiss('delete fail');

         // returnDisplayMsg += ' 嘗試刪除發票號碼: ' + dataIn.clthBillingNumber;

          this.openConfirmModal(MastersKeyStringValue.STATUS_FAIL, returnDisplayMsg);

        });
  }

  normalDelete(configService: any, data: any, tableKey: string) {
    // open the result dialog
    let returnDisplayMsg: string;
    
    // open the result dialog
      configService.deleteData(this.data).subscribe(resultData => {

        this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
          returnDisplayMsg = res;
        });

        this.log.i(this.TAG, "delete success... return msg = " + returnDisplayMsg);
        this.activeModal.close('delete success');
        this.openConfirmModal(MastersKeyStringValue.STATUS_SUCCESS, returnDisplayMsg);
        // window.location.reload();

      }, err => {

      this.translate.get('ReturnStatus_Fail').subscribe((res: string) => {
        returnDisplayMsg = res;
      });

      if(tableKey = MastersKeyStringValue.TABLE_Package){
        returnDisplayMsg += "<br>"+err.error;
      }
      console.log(err);
      this.log.i(this.TAG,"normalDelete tableKey = "+this.tableKeyValue);
      this.activeModal.close('delete fail');
      this.openConfirmModal(MastersKeyStringValue.STATUS_FAIL, returnDisplayMsg);
      // window.location.reload();

    });
  }

  deleteStockData(configService: any, data: StockManagementClass, tableKey: string) {
    // open the result dialog
    let returnDisplayMsg: string;
    this.log.i(this.TAG, "do deleteStockData");

    configService.deleteStockDataByDocNumber(data.detailInfo[0].shopID, data.docNumber).subscribe(resultData => {


      if(resultData.data==true){
        var displayMsg = "";
        this.translate.get('errMesssageYrEnd').subscribe((res: string) => {
          displayMsg = res;
        });
        window.alert(displayMsg);
      }

      this.translate.get('ReturnStatus_Success').subscribe((res: string) => {
        returnDisplayMsg = res;
      });

      this.activeModal.close('delete success');
      this.openConfirmModal(MastersKeyStringValue.STATUS_SUCCESS, returnDisplayMsg);

    }, error => {
      this.translate.get('ReturnStatus_Fail').subscribe((res: string) => {
        returnDisplayMsg = res;
      });
      this.activeModal.close('delete fail');
      this.openConfirmModal(MastersKeyStringValue.STATUS_FAIL, returnDisplayMsg);

    });

  }

  openConfirmModal(status, msg) {
    this.log.i(this.TAG, 'openConfirmModal action = ' + this.action);
    this.log.i(this.TAG, "delete success... return this.tableKeyValue = " + this.tableKeyValue);

     this.apiResultDialogService.openDialog(MastersKeyStringValue.ACTION_MessageDialog, this.tableKeyValue, status, msg);


  }

  


  getDisplayMsg(tableKeyValue) {
    this.log.i(this.TAG, "do deleteFunction " + tableKeyValue);
    // returnMsg: String;
    var returnMsg = "";
    switch (tableKeyValue) {
      case MastersKeyStringValue.TABLE_Bed:
        returnMsg = "你想刪除 " + MastersKeyStringValue.TABLE_Bed + " 的記錄";
        break;
      default:
        break;
    }

    return returnMsg;
  }

}
